import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-api-edit',
  templateUrl: './api-edit.component.html',
  styleUrls: ['./api-edit.component.scss'],
})
export class ApiEditComponent implements OnInit {
  viewData: any = {};
  openList: any;
  urlError: string;
  getApiKeyError: string;
  getSecretKeyError: string;
  accessKeyErrorMessage: string;
  apiNameError: string;
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    this.getAccessKeyById();
    //this.getOpenList();
  }

  getAccessKeyById() {
    this.api.getAccessKeyById(this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.viewData = data;
      this.openList = this.viewData.openAPISettings;
      this.openList.forEach((notification) => {
        notification.apiSettingsResponses.forEach((n) => {
          if (n.notify === 'ON') {
            n.enabled = true;
          } else {
            n.enabled = false;
          }
        });
      });

    }, err => {
      this.alertService.error('Error', err);
    });
  }
  /*
      getOpenList() {
          this.api.getApiSettingsList(this.user.accountOwnerId, "1").subscribe((data: any) => {
            this.openList = data.openApiSettingsResponses;
            this.openList.forEach((notification)=>{
      notification.apiSettingsResponses.forEach((n)=>{
      if(n.notify==='ON'){
      n.enabled =true;
      }else{
      n.enabled = false;
      }
      });
      });

        }, err => {
          console.log(err);
        });
     }
   */

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

  ngOnInit() { }

  save() {

    this.getApiKeyError = "";
    this.getSecretKeyError = "";
    this.urlError = "";
    this.apiNameError = "";

    if (!this.viewData.apiKey) {
      this.getApiKeyError = "Generate the Apikey And SecreteKey";
    }

    if (!this.viewData.secretKey) {
      this.getSecretKeyError = "Generate the Apikey And SecreteKey";
    }

    if (!this.viewData.apiName) {
      this.apiNameError = "Please Enter Api Name";
    }

    if (!this.viewData.redirectUrl) {
      this.urlError = "Please Enter The URL";
    }

    if (this.apiNameError != "" || this.getApiKeyError != "" || this.getSecretKeyError != "" || this.urlError != "") {
      return false;
    }

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/saveAPIKey', {
      "accountOwnerId": this.user.accountOwnerId,
      "apiKey": this.viewData.apiKey,
      "organizationId": this.user.organizationId,
      "redirectUrl": this.viewData.redirectUrl,
      "secretKey": this.viewData.secretKey,
      "apiName": this.viewData.apiName,
      "id": this.route.snapshot.paramMap.get('id')
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Update Successfully', '');
          this.router.navigate(['/admin/myAccountList']);
        }
        else {
          this.accessKeyErrorMessage = data['message'];
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  openUpdateStatus(n) {
    // alert("value ::" + n.displayPriority);
    //if (n.enabled == true) {
    //this.notificationId = n.settingsId;
    //} else {
    //this.notificationId = n.id;
    //}
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createApiSettings', {
      "accountOwnerId": this.user.accountOwnerId,
      "openApiTypeId": n.openApiTypeId,
      "id": n.settingsId,
      "notify": n.enabled ? "OFF" : "ON",
      "organizationId": 1,
      "userApiAccountId": this.route.snapshot.paramMap.get('id')
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == "200") {
          this.alertService.success('Api', 'Status Updated Successfully');
          this.getAccessKeyById();
          // this.getOpenList();
        } else {
          this.alertService.error(data['message']);
          this.getAccessKeyById();
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
